import { createEventEmitter } from "./eventEmitter";

type NavigationEvent = "close-before-navigate";

/**
 * Global event emitter for navigation-related events.
 * Used to coordinate widget closing before page navigation.
 */
export const navigationEvents = createEventEmitter<NavigationEvent, void>();

/**
 * Duration in ms to wait for widget close animation before navigating.
 */
export const CLOSE_ANIMATION_DELAY = 200;

/**
 * Flag indicating that a navigation is pending.
 * When true, widget state should be saved with isVisible: false
 * to prevent the widget from reopening after page navigation.
 */
let navigationPending = false;

export function setNavigationPending(value: boolean): void {
  navigationPending = value;
  // Auto-reset after 5 seconds in case navigation fails or is cancelled
  if (value) {
    setTimeout(() => {
      navigationPending = false;
    }, 5000);
  }
}

export function isNavigationPending(): boolean {
  return navigationPending;
}
